"use client"

import { colors } from "@/components/Providers/ThemeRegistry/theme"
import { ArrowLeft, Grid, List, Person, Trophy } from "@/components/svgs/Svgs"
import { Stack, Typography, alpha } from "@mui/material"
import Link from "next/link"
import { useParams, usePathname } from "next/navigation"
import { useRef } from "react"

type PointsNavItemProps = {
  label: string
  href: string
  icon: React.ReactElement
}

const PointsNavItem = ({ label, href, icon }: PointsNavItemProps) => {
  const pathname = usePathname()
  const isActive = pathname === href
  const ref = useRef<HTMLAnchorElement>(null)
  return (
    <Link
      href={href}
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={() => ref.current?.scrollIntoView({ behavior: "smooth", block: "nearest" })}
    >
      <Typography
        variant="body1"
        fontWeight={500}
        sx={{
          display: "flex",
          alignItems: "center",
          textWrap: "nowrap",
          whiteSpace: "nowrap",
          backgroundColor: isActive ? colors.base.black : alpha(colors.base.black, 0.04),
          color: isActive ? colors.base.white : colors.base.black,
          "&:hover": {
            backgroundColor: isActive ? undefined : alpha(colors.base.black, 0.1),
          },
          borderRadius: "100px",
          padding: "4px 12px 4px 8px",
        }}
      >
        {icon}
        {label}
      </Typography>
    </Link>
  )
}

const campaignPathname = "/points/campaigns"

const PointsNav = () => {
  const pathname = usePathname()
  const isCampaignSubpage = pathname.indexOf(campaignPathname) === 0 && pathname.length > campaignPathname.length

  return (
    <Stack
      direction="row"
      gap="8px"
      sx={{
        my: "20px",
        py: "12px",
        px: "16px",
        overflow: "auto",
        maxWidth: "100%",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {isCampaignSubpage ? (
        <PointsNavItem label="Back" icon={<ArrowLeft />} href="/points/campaigns" />
      ) : (
        <>
          <PointsNavItem label="Campaigns" icon={<Grid />} href="/points/campaigns" />
          <PointsNavItem label="My Points" icon={<Person />} href="/points/me" />
          <PointsNavItem label="Leaderboard" icon={<Trophy />} href="/points/leaderboard" />
          <PointsNavItem label="Rules" icon={<List />} href="/points/rules" />
        </>
      )}
    </Stack>
  )
}

export default PointsNav
